import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from "../svg-icon/svg-icon.module";
import { TrCarouselComponent } from "./tr-carousel.component";

@NgModule({
    imports: [ CommonModule, SvgIconModule ],
    declarations: [ TrCarouselComponent ],
    exports: [ TrCarouselComponent ]
})
export class TrCarouselModule{}